import { MarketplaceFilterAPIStatus } from '@models/section/marketplaceSolutionsSection';
import { atom } from 'jotai';

export const marketplaceFilterAPIStatusAtom = atom<Record<string, MarketplaceFilterAPIStatus>>({});
